<!-- Toast Container -->
<div class="fixed bottom-4 left-4 z-[10000] max-w-md space-y-3">
  <div
    *ngFor="let toast of toasts; trackBy: trackByToastId"
    class="animate-slide-in-left transform transition-all duration-300 ease-in-out"
  >
    <div class="bg-gray-900 dark:bg-gray-100 text-white dark:text-gray-900 px-4 py-3 rounded-lg shadow-lg flex items-center gap-3">
      <svg 
        class="w-5 h-5"
        [ngClass]="getIconClasses(toast.type)"
        fill="none" 
        viewBox="0 0 24 24" 
        stroke="currentColor"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          [attr.d]="getToastIcon(toast.type)"
        />
      </svg>
      
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium">{{ toast.message }}</p>
        <!-- Action button -->
        <button
          *ngIf="toast.action"
          (click)="handleAction(toast)"
          class="mt-1 text-sm font-medium underline hover:no-underline transition-all text-gray-300 dark:text-gray-700 hover:text-white dark:hover:text-gray-900"
        >
          {{ toast.action.label }}
        </button>
      </div>
      
      <button
        (click)="removeToast(toast.id)"
        class="ml-2 text-gray-400 dark:text-gray-600 hover:text-white dark:hover:text-gray-900 transition-colors"
        aria-label="Close notification"
      >
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>
  </div>
</div>